import { EditButton, List, useTable } from "@refinedev/antd";
import { Space, Table, Tag, Typography } from "antd";

const { Text } = Typography;

const TYPE_LABELS: Record<string, string> = {
  TRAINING: "Training",
  FIXTURE: "Fixture",
  STRENGTH_CONDITIONING: "Strength & Conditioning",
  RECOVERY: "Recovery",
  MEETING: "Meeting",
};

const WEEKDAY_ORDER = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

function venueLabel(addr: any): string {
  if (!addr) return "—";
  return addr.formattedAddress || addr.line1 || addr.id || "—";
}

export function SessionTypesList() {
  const { tableProps } = useTable({
    resource: "session_type",
    syncWithLocation: true,
    pagination: { mode: "off" },
    queryOptions: {
      keepPreviousData: false,
      cacheTime: 0,
      staleTime: 0,
    },
  });

  const columns = [
    {
      title: "Session Type",
      dataIndex: "type",
      render: (type: string) => <Text strong>{TYPE_LABELS[type] ?? type}</Text>,
    },
    {
      title: "Time Policy",
      render: (_: any, record: any) =>
        record.timeMode === "FIXED" ? (
          <Tag color="blue">
            Fixed {record.fixedStartTime ?? "??"}–{record.fixedEndTime ?? "??"}
          </Tag>
        ) : (
          <Tag color="green">Editable</Tag>
        ),
    },
    {
      title: "Location Policy",
      render: (_: any, record: any) =>
        record.locationMode === "FIXED" ? (
          <Space direction="vertical" size={0}>
            <Tag color="blue">Fixed venue</Tag>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {venueLabel(record.fixedAddress)}
            </Text>
          </Space>
        ) : (
          <Tag color="green">Editable</Tag>
        ),
    },
    {
      title: "Allowed Weekdays",
      dataIndex: "allowedWeekdays",
      render: (days: string[]) => {
        if (!days || days.length === 0) return <Tag>All days</Tag>;
        const sorted = [...days].sort(
          (a, b) => WEEKDAY_ORDER.indexOf(a) - WEEKDAY_ORDER.indexOf(b)
        );
        return (
          <Space size={4} wrap>
            {sorted.map((d) => (
              <Tag key={d}>{d}</Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.type} />
        </Space>
      ),
    },
  ];

  return (
    <List title="Session Types" canCreate={false}>
      <Table {...tableProps} columns={columns} rowKey="type" pagination={false} />
    </List>
  );
}
